var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"padless":"","id":"common-footer"}},[_c('v-card',{staticClass:"text-center",attrs:{"flat":"","tile":"","width":"100%"}},[_c('v-divider'),_vm._t("sns-share"),_c('CompanyInformation'),_c('ContactButton'),_c('CopyRight')],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }